import { NEW_ACCOUNT_VALUE } from "app/pages/sales-intelligence/domain/crm-integration/constants/account";
import type { CrmAccountRef } from "app/pages/sales-intelligence/domain/crm-integration/types/account";

export const accountsToOptions = (accounts: readonly CrmAccountRef[]): Option[] => {
    return accounts.map((a) => ({ value: a.id, label: a.name }));
};

export type Option = { label: string; value: string; isGroupItem?: boolean; isSuggested?: boolean };

export const allAccountsGroupOption: Option = {
    value: "all-accounts",
    label: "si.advanced_search.account_select.all_accounts",
    isGroupItem: true,
};
export const suggestedAccountsGroupOption: Option = {
    value: "suggestions",
    label: "si.advanced_search.account_select.suggested_accounts",
    isGroupItem: true,
};
export const newAccountOption: Option = { value: NEW_ACCOUNT_VALUE, label: "Create new account" };
